import NextImage, { ImageProps } from "next/image"
import { twMerge } from "tailwind-merge"

export interface ComponentImageProps extends ImageProps {}

const Image: React.FC<ComponentImageProps> = ({ className, blurDataURL, ...props }) => {
  return (
    <NextImage
      className={twMerge("object-contain", className)}
      placeholder={blurDataURL ? "blur" : "empty"}
      blurDataURL={blurDataURL}
      {...props}
    />
  )
}
export default Image
